import { Component, Fragment, type ReactNode } from "react";

interface Props {
  children: ReactNode;
  /** Renders the fallback UI; calling `retry` remounts the children fresh
   *  (state is discarded, mount-time fetches re-run). */
  fallback: (retry: () => void) => ReactNode;
}

interface State {
  hasError: boolean;
  attempt: number;
}

// Mobile audit follow-up (approved incidental) — a malformed server
// response could hard-crash ItemPage to a blank page (no boundary existed
// anywhere in the SPA). Class component because React error boundaries
// have no hook equivalent. The happy path renders children unchanged.
export class PortalErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false, attempt: 0 };

  static getDerivedStateFromError(): Partial<State> {
    return { hasError: true };
  }

  retry = () => {
    this.setState((s) => ({ hasError: false, attempt: s.attempt + 1 }));
  };

  render() {
    if (this.state.hasError) return this.props.fallback(this.retry);
    return <Fragment key={this.state.attempt}>{this.props.children}</Fragment>;
  }
}
